import React from 'react'
import Headerbar  from "./components/common/Headerbar";
import Titlebar  from "./components/common/Titlebar";
import LocationSelectionPage  from "./components/common/LocationSelectionPage";

function LocationSelection() {
  return (
    <><Headerbar /><LocationSelectionPage/></>
  )
}

export default LocationSelection